import { FunctionComponent, useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'

import AuthCardLayout from 'components/layout/auth/authCardLayout'
import * as api from '../api.client'
import { AppMessage } from '../../../utilities/messages'
import { useParams } from 'react-router-dom'
import { PasswordResetInfo } from '../types'
import NewPasswordForm from '../shared/newPasswordForm'

const PasswordReset: FunctionComponent = () => {
  const { token } = useParams<{ token: string }>()
  const [showFormErrors, setShowFormErrors] = useState(false)
  const [appMessage, setAppMessage] = useState<AppMessage>({ show: false })
  const [resetingPassword, setResetingPassword] = useState(false)
  const [updatedCredentials, setUpdatedCredentials] =
    useState<PasswordResetInfo>({
      token: token as string,
      password: '',
      passwordConfirmation: '',
    })

  useEffect(() => {
    if (!token) {
      setAppMessage({
        show: true,
        success: false,
        message:
          'O token necessário para redefinir a senha não foi encontrado.',
      })
    }
  }, [token])

  const resetPassword = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formIsValid = event.currentTarget.checkValidity()

    if (!formIsValid) {
      setShowFormErrors(true)
      return
    }

    setResetingPassword(true)

    try {
      await api.resetPassword(updatedCredentials)
      setAppMessage({
        show: true,
        success: true,
        message: 'Senha redefinida com sucesso.',
      })
    } catch (error) {
      setAppMessage({
        show: true,
        success: false,
        message: (error as any).messages.join(', '),
      })
    } finally {
      setResetingPassword(false)
    }
  }

  const handleFormChange = ({
    target,
  }: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = target

    setUpdatedCredentials({ ...updatedCredentials, [name]: value })
  }

  return (
    <AuthCardLayout title="Criar nova senha" subtitle="Defina a nova senha de acesso.">
      {appMessage.show && (
        <Alert variant={appMessage.success ? 'success' : 'danger'}>
          {appMessage.message}
        </Alert>
      )}
      <NewPasswordForm
        values={updatedCredentials}
        onChange={handleFormChange}
        onSubmit={resetPassword}
        validated={showFormErrors}
        submitting={resetingPassword}
        disabled={!token}
        submitLabel="Salvar senha"
        passwordLabel="Nova senha"
        confirmationLabel="Confirmar nova senha"
      />
    </AuthCardLayout>
  )
}

export default PasswordReset
